import React from 'react'
import useNavigation from 'hooks/useNavigation'
import {
  Drawer,
  Container,
  ContentContainer,
  Header,
  Title,
  Body,
  ButtonStyled,
  ErrorCross
} from './styles'
import { Box } from '@chakra-ui/react'
import { Drawers } from 'store/drawer/types'
import wrapper from 'components/organisms/Drawers/wrapper'
import { useSelector } from 'react-redux'

interface Props {
  showDrawer: boolean
  onClose: () => void
}

const AddHumanPersonError: React.FC<Props> = ({ showDrawer, onClose }) => {
  const { onNavigate } = useNavigation()
  const { data } = useSelector((state: any) => state.drawer)

  const onPress = () => {
    onClose()
    onNavigate('/content/your-enterprises')
  }

  return (
    <Drawer open={showDrawer} onClose={onClose} direction="right">
      <Container>
        <Header />
        <ContentContainer>
          <ErrorCross />
          <Title>Ocurrió un error.</Title>
          <Body>{data[Drawers.ADD_HUMAN_PERSON_ERROR].error}</Body>
        </ContentContainer>
        <Box display="flex" flexDir="column" width="100%">
          <ButtonStyled onPress={onPress} disabled={false}>
            Reintentar
          </ButtonStyled>
        </Box>
      </Container>
    </Drawer>
  )
}

export default wrapper(AddHumanPersonError, Drawers.ADD_HUMAN_PERSON_ERROR)
